import PrivacyContainer from "@/pages/privacy";
import SupportContainer from "@/pages/support";
import { PATH_PRIVACY_POLICY, PATH_SUPPORT } from "./paths";

const miscRoutes = [
  {
    path: PATH_PRIVACY_POLICY,
    element: <PrivacyContainer />,
  },
  {
    path: PATH_SUPPORT,
    element: <SupportContainer />,
  }
];

export default miscRoutes;
